import * as _ from 'lodash';
const initialState: any = {
    pins: []
}

const pinReducer = (state = initialState, action: any): any => {
    if (action.type === 'PIN_DATA') {
        const dataUniq = _.uniqBy([...state.pins, action.payload], function (item) { return item.appointmentId; });
        return {
            ...state,
            pins: dataUniq.map((item) => {
                if (item.appointmentId === action.payload.appointmentId) {
                    return {
                        ...item,
                        openPin: action.payload.openPin ? true : false
                    };
                }
                return {
                    ...item,
                    openPin: false
                }
            })
        }
    } else if (action.type === 'REMOVE_PIN') {
        const processedData = _.unionBy([...state.pins].filter((item) => item.appointmentId !== action.payload));
        return {
            ...state,
            pins: processedData
        }
    } else if (action.type === 'CLOSE_PIN') {
        return {
            ...state,
            pins: state.pins.map((item: any) => {
                return {
                    ...item,
                    openPin: false
                }
            })
        }
    }
    return state;

}

export default pinReducer;